import useCommonStore, { ModalConfig } from '@/stores/common';
import { DialogTitle, Description } from '@headlessui/react';
import React from 'react';

const ConfirmModal: React.FC = () => {
  const { modalConfig = {} as ModalConfig, hideCommonModal } = useCommonStore<{
    modalConfig?: ModalConfig;
    hideCommonModal: () => void;
  }>(state => state);
  return (
    <div className='flex flex-col items-center gap-1 md:gap-2 pt-1 md:pt-2 pb-3 md:pb-4 px-2 md:px-3 text-center max-w-sm mx-auto w-full'>
      {modalConfig?.data?.title && (
        <DialogTitle
          as='h2'
          className='text-base md:text-lg font-bold text-gray-900'
        >
          {modalConfig.data.title}
        </DialogTitle>
      )}
      {modalConfig?.data?.message && (
        <Description className='text-sm text-gray-600'>
          {modalConfig.data.message}
        </Description>
      )}
      <div className='flex gap-2 md:gap-3 justify-center pt-1 md:pt-2 w-full'>
        <button
          type='button'
          className='px-4 py-1.5 md:py-2 text-sm bg-transparent border border-gray-300 text-slate-700 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 min-w-[70px]'
          onClick={() => {
            if (modalConfig?.onClose) {
              modalConfig.onClose();
            } else {
              hideCommonModal();
            }
          }}
        >
          No
        </button>
        <button
          type='button'
          className='px-4 py-1.5 md:py-2 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[70px]'
          onClick={() => {
            if (modalConfig?.onClick) {
              modalConfig.onClick();
            }
          }}
        >
          Yes
        </button>
      </div>
    </div>
  );
};

export default ConfirmModal;
